import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Button, ConfirmAbortModal, Input, Modal, Checkbox } from "@ts-digital/vrc";
import numeral from "numeral";

import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import TSDialog from "../../general/dialog";
import { Select } from "antd";
import { DATE_FORMAT_FOR_DISPLAY, DATE_FORMAT_FOR_API } from "../../../constants/constants";
import { deadlinesPayment } from "../../../constants/scadenze";
import { FormattedMessage } from "react-intl";
import TSPayShareDialog from "../../general/tspay/shareDialog";
import { FEATURE_TOGGLE_TSPAY } from "../../../config";
import AuthorizeDialog from "./dialogs/authorizeDialog";
import NotAuthorizeDialog from "./dialogs/notAuthorizeDialog";
import { splitDeadlines } from "../../../store/actions/deadlines/detail";
import { getTSPayLink } from "../../../store/actions/tspay";
import { createReconciliationLink, getReconciledSummary } from "../../../store/actions/reconciliation/operations";
import DeadlinesRegisterDrawer from "./register";
import LoaderSimple from "../../general/loader";
import { tspayLimit } from "../../../constants/tspay";
import imgTSPayAzzurro from "../../../assets/img/logo-ts-pay_azzurro.svg";
import { delay } from "../../../libs/utils";
import { VaporDatePicker } from "../../vapor";

const { Option } = Select;

const ButtonsActionDeadlines = (props) => {
  const {
    auth,
    accountantSelectedRagSoc,
    hasAuthorize,
    updatePayment,
    hasReject,
    isPayed,
    isManagerPays,
    isStudio,
    isFiscalSocialSecurity,
    setAuthorize,
    setPayment,
    setUnauthorize,
    isAuthorizationPermission,
    isAuthorizationFiscalPermission,
    paymentType,
    clientIdSelected,
    accountantUuidSelected,
    companyUuidSelected,
    getDetailDetailsById,
    reconciliated,
    isToPay
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tspay = useSelector((state) => state.tspay);
  const deadlinesDetail = useSelector((state) => state.deadlinesDetail);
  const infoDeadline = deadlinesDetail.subjective;

  const [visibleAuthorizeDialog, setVisibleAuthorizeDialog] = useState(false);
  const [visibleNotAuthorizeDialog, setVisibleNotAuthorizeDialog] = useState(false);
  const [visibleRefuseDialog, setVisibleRefuseDialog] = useState(false);
  const [,/* visibleRegisterDialog, setVisibleRegisterDialog*/] = useState(false);
  const [visibleRegisterDrawer, setVisibleRegisterDrawer] = useState(false);
  // const [visibleTsPayDialog, setVisibleTsPayDialog] = useState(false);
  const [visibleTsPayMailDialog, setVisibleTsPayMailDialog] = useState(false);
  const [visibleAlertDialog, setVisibleAlertDialog] = useState(false);
  const [visibleDetailSplit, setVisibleDetailSplit] = useState(false);
  // const [disableRegister, setDisableRegister] = useState(false);
  const [, setImportValue] = useState("");
  const [amountToPay, setAmountToPay] = useState(Math.abs(infoDeadline.totalAmount));
  const [paymentValue /* setPaymentValue*/] = useState(paymentType && paymentType.mode.id
    ? paymentType.mode.id
    : paymentType.execution && paymentType.execution.id
      ? paymentType.id
      : isFiscalSocialSecurity
        ? "PM01"
        : "PM05");
  const [paymentNewDeadline, setPaymentNewDeadline] = useState(paymentType && paymentType.mode.id
    ? paymentType.mode.id
    : paymentType.execution && paymentType.execution.id
      ? paymentType.id
      : isFiscalSocialSecurity
        ? "PM01"
        : "PM05");
  const [dateValue, setDateValue] = useState(moment(new Date()).format(DATE_FORMAT_FOR_DISPLAY));
  const [dateNewDeadline, setDateNewDeadline] = useState(moment(infoDeadline.date));
  const [checkbox, setCheckbox] = useState(false);
  const [configStatus, setConfigStatus] = useState("");

  const refusePage = 1;
  const isSuspended = infoDeadline.payment.status === "suspended";

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, [tspay]);

  useEffect(() => {
    setAmountToPay(Math.abs(infoDeadline.totalAmount));
  }, [infoDeadline.totalAmount]);

  useEffect(() => {
    dispatch(getTSPayLink(
      auth, companyUuidSelected, accountantUuidSelected, infoDeadline.id
    ));
  }, []);

  const handleChange = () => {
    setCheckbox(!checkbox);
  };

  const toggleAuthorizeDialog = () => {
    setVisibleAuthorizeDialog(!visibleAuthorizeDialog);
  };

  const toggleNotAuthorizeDialog = () => {
    setVisibleNotAuthorizeDialog(!visibleNotAuthorizeDialog);
  };

  const openCloseRefuseDialog = () => {
    setVisibleRefuseDialog(!visibleRefuseDialog);
  };

  const toggleAlertDialog = () => {
    setVisibleAlertDialog(!visibleAlertDialog);
    setImportValue("");
    setAmountToPay(infoDeadline.totalAmount);
    setDateValue(moment(new Date()).format(DATE_FORMAT_FOR_API));
    // renderRegisterDialog(); NB: perché qui viene ripetuta la chiamata alla render?
  };

  const toggleSplitDialog = () => {
    setVisibleDetailSplit(!visibleDetailSplit);
  };

  const toggleRegisterDrawer = () => {
    setVisibleRegisterDrawer(!visibleRegisterDrawer);
  };

  const toggleTsPayMailDialog = () => {
    // document.getElementsByTagName("body")[0].style.overflow = !visibleTsPayMailDialog ? "hidden" : "scroll";
    setVisibleTsPayMailDialog(!visibleTsPayMailDialog);
  };

  const getNewDeadlineId = (res) => {
    const newDeadlineToPay = res?.created?.find((d) => d.payment.step === "to_be_paid" || d.payment.step === "rebated" || d.payment.step === "to_be_collected");
    const newDeadlineToPayId = newDeadlineToPay?.id;
    return newDeadlineToPayId;
  };

  const getNewDeadlineIdPaid = (res) => {
    const newDeadlinePaid = res?.created?.find((d) => d.payment.step === "paid" || d.payment.step === "collected");
    const newDeadlinePaidId = newDeadlinePaid?.id;
    return newDeadlinePaidId;
  };

  const onCloseWithResidue = (
    res, saveReconciliation, selectedMovements
  ) => {
    setVisibleRegisterDrawer(!visibleRegisterDrawer);
    const deadlineId = getNewDeadlineIdPaid(res);
    let linkList = [];
    if (saveReconciliation) {
      let movementsIdList = Object.keys(selectedMovements);
      movementsIdList.forEach((bankTransactionId) => linkList.push({ deadlineId, bankTransactionId }));
      // Procedura di pagamento con riconciliazione bancaria
      dispatch(createReconciliationLink(
        auth, accountantUuidSelected, companyUuidSelected, linkList, "DEADLINE"
      )).then((res) =>
        delay(3000).then(() => dispatch(getReconciledSummary())));
    }
    const id = getNewDeadlineId(res);
    navigate({
      pathname: `/scadenza/${id}`
    });
    window.location.reload(); // serve???
  };

  const renderRefuseDialog = () => {
    let today = new Date();
    let title = refusePage === 1 ? <FormattedMessage id="deadlines.pages.detail.confirmRejection" /> : <FormattedMessage id="deadlines.pages.detail.addNote" />;
    let okText = refusePage === 1 ? <FormattedMessage id="deadlines.pages.detail.reject" /> : <FormattedMessage id="deadlines.pages.detail.saveNote" />;
    let cancelText = refusePage === 1 ? <FormattedMessage id="actions.cancel" /> : <FormattedMessage id="actions.close" />;
    let typeDialog = refusePage === 1 ? "danger" : "primary";

    return (
      <TSDialog
        title={title}
        okText={okText}
        cancelText={cancelText}
        type={typeDialog}
        visible={visibleRefuseDialog}
        onAbort={openCloseRefuseDialog}
        onSubmit={
          refusePage === 1
            ? (e) => {
              if (window.aptrinsic) {
                window.aptrinsic("track", "digital-box:DEADLINES-PAYMENT-REFUSE");
              }
              setPayment(
                "unpaid", "0000", moment(today).format(DATE_FORMAT_FOR_API)
              );
              openCloseRefuseDialog();
            }
            : () => {}
        }
      >
        {renderRefuseMessage()}
      </TSDialog>
    );
  };

  const renderRefuseMessage = () => {
    return (
      <div>
        <FormattedMessage id="deadlines.pages.detail.refuseMessage1" />
        <br />
        <FormattedMessage id="deadlines.pages.detail.refuseMessage2" />
        {accountantSelectedRagSoc}
        <FormattedMessage id="deadlines.pages.detail.refuseMessage3" />
        <br />
        <br />
        <FormattedMessage id="deadlines.pages.detail.refuseMessage4" />
      </div>
    );
  };

  const ButtonsAuthorize = () => {
    /** Bottoni visibili lato cliente con scadenza attuale e da pagare dallo studio */
    return (
      <div>
        {hasAuthorize && !infoDeadline.status.authorized && !infoDeadline.status.rejected ? (
          <div style={{ display: "inline-block", marginRight: "16px" }}>
            <Button className="gs-deadlines-actions-payment-authorize" onClick={toggleAuthorizeDialog}>
              <FormattedMessage id="deadlines.pages.detail.authorize" />
            </Button>
          </div>
        ) : null}
        {hasReject && !infoDeadline.status.authorized && !infoDeadline.status.rejected ? (
          <div style={{ display: "inline-block" }}>
            <Button className="gs-deadlines-actions-payment-not-authorize" onClick={toggleNotAuthorizeDialog} kind="secondary" colorScheme={"ghost"}>
              <FormattedMessage id="deadlines.pages.detail.dontAuthorize" />
            </Button>
          </div>
        ) : null}
        {
          <AuthorizeDialog
            visibleAuthorizeDialog={visibleAuthorizeDialog}
            toggleAuthorizeDialog={toggleAuthorizeDialog}
            setAuthorize={setAuthorize}
            accountantSelectedRagSoc={accountantSelectedRagSoc}
            totalToPay={Math.abs(infoDeadline.totalAmount)}
            isManagerPays={isManagerPays}
          />
        }
        {
          <NotAuthorizeDialog
            toggleNotAuthorizeDialog={toggleNotAuthorizeDialog}
            visibleNotAuthorizeDialog={visibleNotAuthorizeDialog}
            setUnauthorize={setUnauthorize}
            accountantSelectedRagSoc={accountantSelectedRagSoc}
          />
        }
      </div>
    );
  };

  const ButtonReconciliation = () => {
    return (
      <div>
        <Button className="gs-deadlines-actions-payment-confirm reconciliation" kind="secondary" onClick={() => toggleRegisterDrawer()}>
          <div style={{ display: "flex" }}>
            <div style={{ marginRight: "10px" }}>
              <FontAwesomeIcon cursor="pointer" icon={["far", "university"]} />
            </div>
            <div>
              <FormattedMessage id="deadlines.reconciliation.title" />
            </div>
          </div>
        </Button>
        {visibleRegisterDrawer && (
          <DeadlinesRegisterDrawer
            accountantUuidSelected={accountantUuidSelected}
            companyUuidSelected={companyUuidSelected}
            onClose={() => {
              toggleRegisterDrawer();
            }}
            onCloseWithResidue={onCloseWithResidue}
            visibleRegisterDrawer={visibleRegisterDrawer}
            onPaymentComplete={() => {
              toggleRegisterDrawer();

              getDetailDetailsById(infoDeadline.id);
            }}
            paymentType={paymentType}
            isFiscalSocialSecurity={isFiscalSocialSecurity}
            setPayment={setPayment}
            splitDeadlines={splitDeadlines}
            isStudio={isStudio}
            isToPay={isToPay}
          />
        )}
      </div>
    );
  };

  const ButtonsRegister = () => {
    /** Bottoni visibili lato cliente con scadenza attuale e da pagare dal cliente */
    return (
      <div>
        {updatePayment &&
        !isPayed &&
        ((!isFiscalSocialSecurity && isAuthorizationPermission) || (isFiscalSocialSecurity && isAuthorizationFiscalPermission)) ? (
            !deadlinesDetail.isLoadingPreview ? (
              <div>
                <div style={{ display: "inline-block", marginRight: "16px" }}>
                  <Button disabled={isSuspended ? true : false} className="gs-deadlines-actions-payment-confirm" onClick={toggleRegisterDrawer}>
                    <FormattedMessage id={infoDeadline.totalAmount < 0 ? "deadlines.pages.detail.registerPayment" : "deadlines.pages.detail.registerCollect"} />
                  </Button>
                </div>
                {infoDeadline.totalAmount < 0 && configStatus === "LINKED" && FEATURE_TOGGLE_TSPAY === "true" && !isFiscalSocialSecurity && (
                  <div style={{ display: "inline-block", marginRight: "16px" }}>
                    <Tooltip
                      color={"rgb(0, 80, 117)"}
                      title={
                        infoDeadline.totalAmount < tspayLimit * -1 ? (
                          <FormattedMessage
                            id={"deadlines.pages.detail.limitTipTsPayPayment"}
                            values={{
                              limit: numeral(tspayLimit).format("0,0.00") + " €"
                            }}
                          />
                        ) : null
                      }
                    >
                      <div>
                        <Button
                          data-testid="registerPaymentWithTsPay"
                          disabled={isSuspended || infoDeadline.totalAmount < tspayLimit * -1 ? true : false}
                          // className="gs-deadlines-actions-payment-confirm tspay"
                          kind="tertiary"
                          onClick={() => {
                            navigate("/tspay-payment", {
                              state: {
                                deadlines: [infoDeadline],
                                backTo: window.location.hash.replace("#/", "/")
                              }
                            });
                            if (window.aptrinsic) {
                              window.aptrinsic("track", "digital-box:TSPAY-PAGASUBITO");
                            }
                          }}
                        >
                          <FormattedMessage id={"deadlines.pages.detail.registerPaymentWithTsPay"} />
                        </Button>
                      </div>
                    </Tooltip>
                  </div>
                )}

                {infoDeadline.totalAmount > 0 && configStatus === "LINKED" && FEATURE_TOGGLE_TSPAY === "true" && !isFiscalSocialSecurity && (
                  <div style={{ display: "inline-block", marginRight: "16px" }}>
                    <Button
                      disabled={isSuspended ? true : false}
                      className="gs-deadlines-actions-payment-confirm tspay"
                      kind="tertiary"
                      onClick={() => {
                        toggleTsPayMailDialog();
                        if (window.aptrinsic) {
                          window.aptrinsic("track", "digital-box:TSPAY-RICHIEDIPAGAMENTO");
                        }
                      }}
                    >
                      <FormattedMessage id={"deadlines.pages.detail.sendTsPayMail"} />
                      <img src={imgTSPayAzzurro} alt="logo_tspay_azzurro" />
                    </Button>
                  </div>
                )}
                <div
                  style={{
                    display: isSuspended ? "inline-block" : "none",
                    marginRight: "16px"
                  }}
                >
                  <Tooltip
                    color={"rgb(0, 80, 117)"}
                    title={
                      <div>
                        {"Per abilitare queste funzionalità riattiva la scadenza"}
                        <FontAwesomeIcon
                          style={{
                            color: "#ffffff",
                            fontSize: "14px",
                            marginLeft: "5px"
                          }}
                          icon={["far", "play-circle"]}
                        />
                      </div>
                    }
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#0090d1",
                        fontSize: "16px",
                        marginRight: "4px",
                        cursor: "pointer"
                      }}
                      icon={["far", "info-circle"]}
                    />
                  </Tooltip>
                </div>
                {isFiscalSocialSecurity && infoDeadline.totalAmount < 0 ? (
                  <div style={{ display: "inline-block" }}>
                    <Button className="gs-deadlines-actions-payment-reject" onClick={openCloseRefuseDialog} kind="secondary" colorScheme={"ghost"}>
                      <FormattedMessage id="deadlines.pages.detail.dontPay" />
                    </Button>
                  </div>
                ) : null}
              </div>
            ) : (
              <div>
                <LoaderSimple />
              </div>
            )
          ) : null}
        {visibleRegisterDrawer && (
          <DeadlinesRegisterDrawer
            accountantUuidSelected={accountantUuidSelected}
            companyUuidSelected={companyUuidSelected}
            onClose={() => {
              toggleRegisterDrawer();
            }}
            onCloseWithResidue={onCloseWithResidue}
            visibleRegisterDrawer={visibleRegisterDrawer}
            onPaymentComplete={() => {
              toggleRegisterDrawer();

              getDetailDetailsById(infoDeadline.id);
            }}
            paymentType={paymentType}
            isFiscalSocialSecurity={isFiscalSocialSecurity}
            setPayment={setPayment}
            splitDeadlines={splitDeadlines}
            isToPay={isToPay}
          />
        )}

        {/* <RegisterDialog
            toggleRegisterDialog={toggleRegisterDialog}
            visibleRegisterDialog={visibleRegisterDialog}
            disableRegister={disableRegister}
            isFiscalSocialSecurity={isFiscalSocialSecurity}
            paymentValue={paymentValue}
            dateValue={dateValue}
            setPayment={setPayment}
            amountToPay={amountToPay}
            infoDeadline={infoDeadline}
            setVisibleAlertDialog={setVisibleAlertDialog}
            visibleAlertDialog={visibleAlertDialog}
            setVisibleDetailSplit={setVisibleDetailSplit}
            visibleDetailSplit={visibleDetailSplit}
            setVisibleRegisterDialog={setVisibleRegisterDialog}
            totalToPay={Math.abs(infoDeadline.totalAmount)}
            setDisableRegister={setDisableRegister}
            onChangeAmountToPay={val => {
              setAmountToPay(val);
            }}
            setDateValue={setDateValue}
            setPaymentValue={setPaymentValue}
          />*/}

        {renderRefuseDialog()}
        {renderSplitDialog()}
        {visibleTsPayMailDialog && configStatus === "LINKED" && (
          <TSPayShareDialog
            auth={auth}
            companyUuidSelected={companyUuidSelected}
            clientIdSelected={clientIdSelected}
            visibleDialog={visibleTsPayMailDialog}
            onClose={() => setVisibleTsPayMailDialog(false)}
          ></TSPayShareDialog>
        )}
      </div>
    );
  };

  /* const onFocusWidget = e => {
    if (e.target.name) {
      setActiveName(e.target.name);
    }
  };*/

  function SplitAndRedirect(newList) {
    dispatch(splitDeadlines(
      infoDeadline.id, newList, true
    )).then(() => {
      toggleSplitDialog();
      navigate({
        pathname: "/scadenzecliente",
        state: { reloadData: true, viewType: "calendar" }
      }); 
    });
  }

  const renderSplitDialog = () => {
    let modePayment = [];
    for (let key in deadlinesPayment) {
      if (deadlinesPayment.hasOwnProperty(key) && key !== "PMXA") {
        modePayment.push(<Option value={key}>
          <b>
            <FormattedMessage id={deadlinesPayment[key]} />
          </b>
        </Option>);
      }
    }
    return (
      <Modal
        outsideClosable={false}
        type="primary"
        onClose={toggleSplitDialog}
        title={<FormattedMessage id="deadlines.pages.detail.newDeadlineResidue" />}
        visible={visibleDetailSplit}
        footer={
          <div style={{ padding: "8px 0", width: "100%", textAlign: "right" }}>
            <Button kind="secondary" colorScheme={"ghost"} style={{ marginRight: "16px" }} className="buttonNav" onClick={toggleRegisterDrawer}>
              <FormattedMessage id="generic.back" />
            </Button>
            <div style={{ display: "inline-block" }}>
              <Button
                style={{ marginRight: "16px" }}
                className="buttonNav"
                onClick={(e) => {
                  const newList = [];
                  newList.push({
                    date: typeof infoDeadline.date === "string" ? new Date(infoDeadline.date) : infoDeadline.date,
                    amount: infoDeadline.payment.type === "item_pays" ? -amountToPay : amountToPay,
                    paymentModeId: paymentValue,
                    execution: {
                      mode: paymentValue,
                      date: dateValue
                    },
                    paymentStatus: "paid"
                  },
                  {
                    date: typeof dateNewDeadline === "string" ? new Date(dateNewDeadline) : dateNewDeadline,
                    amount:
                        infoDeadline.payment.type === "item_pays"
                          ? Number(infoDeadline.totalAmount) + Number(amountToPay)
                          : Number(infoDeadline.totalAmount) - Number(amountToPay),
                    paymentModeId: paymentNewDeadline,
                    paymentStatus: checkbox ? "suspended" : "due"
                  });
                  SplitAndRedirect(newList);
                }}
              >
                <FormattedMessage id="generic.save" />
              </Button>
            </div>
          </div>
        }
      >
        <div
          style={{
            marginBottom: "30px",
            marginTop: "20px",
            fontSize: "16px",
            alignItems: "baseline"
          }}
        >
          <b>
            {"L'importo che stai registrando ("}
            {Math.abs(amountToPay).toFixed(2).replace(".", ",")}
            {" € del "}
            {moment(infoDeadline.date).format("DD/MM/YYYY")}
            {") con "}
            {<FormattedMessage id={"deadlines.payment." + paymentValue} />}
            {" non copre il totale di "}
            {Math.abs(infoDeadline.totalAmount).toFixed(2).replace(".", ",")}
            {" €."}
          </b>
          <br />
          {"Stai creando una nuova scadenza per il saldo residuo di: "}{" "}
          {infoDeadline.description.title + "" + (infoDeadline.description.details ? infoDeadline.description.details : "")}
        </div>
        <div style={{ maxWidth: "800px", width: "80vw" }}>
          <div style={{ display: "flex", fontWeight: "500", marginBottom: "10px" }}>
            <div style={{ width: "65px", marginRight: "20px" }}></div>
            <div className="amountDiv">
              <FormattedMessage id="deadlines.amountEuro" />
            </div>
            <div className="amountDiv">
              <FormattedMessage id="deadlines.deadlineDateColumn" />
            </div>
            <div className="amountDiv">
              <FormattedMessage id="deadlines.pages.detail.paymentType" />{" "}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              fontWeight: "500",
              marginBottom: "35px",
              alignItems: "baseline"
            }}
          >
            <div className="labelDiv">
              <FormattedMessage id="deadlines.due" />
            </div>
            <div className="amountDiv">
              <Input
                id="2"
                disabled={true}
                value={
                  infoDeadline.payment.type === "item_pays"
                    ? Math.abs(Number(infoDeadline.totalAmount) + Number(amountToPay))
                      .toFixed(2)
                      .replace(".", ",")
                    : Math.abs(Number(infoDeadline.totalAmount) - Number(amountToPay))
                      .toFixed(2)
                      .replace(".", ",")
                }
                onChange={() => {}}
              />
            </div>
            <div className="amountDiv">
              <VaporDatePicker
                getPopupContainer={(trigger) => trigger.parentNode}
                allowClear={false}
                placeholder={"gg/mm/aaaa"}
                value={dateNewDeadline}
                onChange={(value) => {
                  setDateNewDeadline(value);
                }}
              />
            </div>
            <div style={{ marginRight: "25px" }} className="customPaymentSelectModalStep2">
              <Select
                dropdownClassName="modalOverlay"
                onChange={(value) => {
                  setPaymentNewDeadline(value);
                }}
                showSearch
                filterOption={(input, option) => option.props.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                value={<FormattedMessage id={"deadlines.payment." + paymentNewDeadline} />}
              >
                {modePayment}
              </Select>
            </div>
            <div style={{ marginTop: "10px" }}>
              <Checkbox onChange={handleChange} checked={checkbox} label="Sospendi"></Checkbox>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  const BtnsClient = () => {
    return !isStudio ? (
      <div>
        {<ButtonsAuthorize />}
        {<ButtonsRegister />}
      </div>
    ) : (
      <div>{!reconciliated ? <ButtonReconciliation /> : null}</div>
    );
  };

  return (
    <div>
      <div>
        <BtnsClient />
      </div>
      <div>
        <ConfirmAbortModal
          className="confirmModal"
          // style={{zIndex: 999999 }}
          visible={visibleAlertDialog}
          title={<FormattedMessage id="deadlines.amountNotValid" />}
          onAbort={(e) => {
            setVisibleAlertDialog(!visibleAlertDialog);
          }}
          onConfirm={(e) => {
            toggleAlertDialog();
          }}
          abortText={<FormattedMessage id="actions.cancel" />}
          confirmText={<FormattedMessage id="actions.correct" />}
        >
          <div style={{ padding: "30px 0" }}>
            <FormattedMessage id="deadlines.adviceAmountNotValid" />
          </div>
        </ConfirmAbortModal>
      </div>
    </div>
  );
};

export default ButtonsActionDeadlines;
